exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "gz-field{color:#5a5a5a}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!../~/@printos/gazelle/src/components/fields/field/field.scss
// module id = 106
// module chunks = 0